/**
 * Dati di dettaglio per tutte le 29 associazioni
 * Sorgente: confcommercioroma.it (crawled)
 */

const ASSOC_DETTAGLIO = [

  // ── FEDERAZIONI E ASSOCIAZIONI DI CATEGORIA ─────────────────────────

  {
    id: "abiconf",
    urlOriginale: "https://www.confcommercioroma.it/associazioni/abiconf-roma/",
    intro: [
      "ABICONF ROMA è l'Associazione di riferimento per il territorio di Roma e Provincia di ABICONF – Amministratori Beni Immobili Confcommercio, costituita nell'ambito di Confcommercio nazionale. Ha sede operativa presso Confcommercio Roma.",
      "ABICONF rappresenta gli Amministratori di condominio aderenti ed esercenti la libera professione, ma anche gli Amministratori di patrimoni immobiliari e i revisori di contabilità condominiale, organizzati in appositi e distinti elenchi.",
      "ABICONF è soggetto di riferimento per lo studio ed applicazione del diritto condominiale: organizza, attraverso proprie sedi territoriali ed enti di formazione, corsi di avviamento ed aggiornamento alla professione di Amministratore di condominio, ex DM. 140/2014.",
    ],
    serviziTitolo: "Cosa offriamo ai nostri associati",
    servizi: [
      "Rappresentanza istituzionale a livello Nazionale e Locale",
      "Networking e consulenza con aziende e altri professionisti",
      "Accesso al credito con Fin.Promo.Ter S.C.P.A., con finanziamenti agevolati e supporto nella garanzia di finanziamenti bancari",
      "Corsi Base e corsi avanzati di Aggiornamento per la professione di Amministratore di condominio (ex DM. 140/2014)",
      "Newsletter informative e consulenze su appuntamento in materia fiscale, contabile, legale, assicurativa e tecnica",
      "Servizi assicurativi: Globale fabbricati e Gestione sinistri",
      "Consulenza giuridica e assistenza in materia di Sicurezza sul lavoro, Privacy GDPR, Certificazioni di Qualità e Modello 231",
      "Sportello del Consumatore e Sportello del Condominio",
    ],
    presidente: {
      nome: "Claudio De Fenu",
      foto: "https://www.confcommercioroma.it/wp-content/uploads/2021/12/FOTO-243x300.jpg",
      bio: [
        "Claudio De Fenu è presidente di Abiconf Roma dal marzo 2024. Avvocato appartenente al foro di Roma, ha maturato un'esperienza ventennale nei settori della contrattualistica e del Diritto civile, con una particolare vocazione per il settore immobiliare e condominiale.",
        "Avvocato fiduciario di diverse agenzie immobiliari (Frimm – Toscano – Mr Case) e dell'Associazione Nazionale \"Scarabocchiando a casa di…\" finalizzata all'apertura di nidi famiglia in tutto il territorio nazionale, ha partecipato da relatore a diversi convegni come esperto in materia condominiale. Parallelamente all'attività di avvocato, guida l'omonima Azienda Agricola De Fenu.",
      ],
    },
    consiglio: [
      { nome: "Claudio De Fenu", ruolo: "Presidente" },
      { nome: "Alessandro Pangia", ruolo: "Vicepresidente" },
      { nome: "Silvio Donati", ruolo: "Consigliere" },
      { nome: "Fabiana Flecchia", ruolo: "Consigliere" },
      { nome: "Giovanni Notaro", ruolo: "Consigliere" },
      { nome: "Federico Mastrostefano", ruolo: "Consigliere" },
      { nome: "Dario Latini", ruolo: "Consigliere" },
    ],
    contatti: {
      referente: "Vanessa Tatini",
      indirizzo: "Via Marco e Marcelliano, 45 – 00147 Roma",
      email: "abiconfroma@confcommercioroma.it",
      tel: "06.68437235",
    },
    links: [
      { label: "Scarica la scheda", url: "https://www.confcommercioroma.it/wp-content/uploads/2025/09/SCHEDA_ABICONF_050525-2-1.pdf", tipo: "download" },
    ],
  },

  {
    id: "ali-roma",
    urlOriginale: "https://www.confcommercioroma.it/associazioni/ali-roma/",
    intro: [
      "ALI ROMA è l'Associazione composta da librai indipendenti che hanno come obiettivo comune il sostegno e la promozione della cultura.",
      "L'Associazione tutela gli interessi delle librerie e delle aziende commissionarie presenti sul territorio di Roma e provincia, portando all'attenzione delle istituzioni e delle amministrazioni locali le istanze e le esigenze dei propri associati per ottenere politiche e interventi favorevoli al settore librario e allo sviluppo culturale del territorio.",
      "ALI ROMA lavora per garantire che i librai associati abbiano accesso alle risorse e alle informazioni di cui hanno bisogno per gestire con successo le loro attività.",
      "Organizza eventi e attività formative per l'accelerazione dell'innovazione delle librerie del territorio, avvalendosi della collaborazione di enti pubblici e privati e, in collaborazione con la rete d'imprese LIBRERIE DI ROMA, contribuisce allo sviluppo di progetti imprenditoriali e tecnologici per il rafforzamento infrastrutturale delle librerie del territorio.",
    ],
    presidente: {
      nome: "Ilaria Milana",
      foto: "https://www.confcommercioroma.it/wp-content/uploads/2021/12/ILARIA-MILANA-300x249.png",
      bio: [
        "Ilaria Milana è un'imprenditrice culturale, attiva nella rappresentanza di categoria, nella formazione imprenditoriale e nell'innovazione. Dopo la laurea in Psicologia e un master in \"Sviluppo e Selezione delle Risorse Umane\", ha lavorato in ambito HR dal 1990 al 2001, prima come consulente presso la Società MTA-SHL poi come Quadro in Tim Spa.",
        "Nel 2000, fonda Voltapagina Srl e apre la libreria in franchising a via Piave 18 a Roma, promuovendo progetti culturali su vasta scala. Dal 2011 è membro del Consiglio Nazionale dell'Associazione Librai Italiani (Ali-Confcommercio), dal 2015 dirige e sviluppa la Scuola di Alta Formazione in Gestione della Libreria, dal 2021 è Presidente di Ali Roma e dal 2023 è Vice Presidente di Confcommercio Roma.",
        "Dal 2019, si dedica a progetti di innovazione in qualità di Business Designer e Team Builder.",
      ],
    },
    consiglio: [
      { nome: "Ilaria Milana", ruolo: "Presidente" },
      { nome: "Alessandro Alessandroni", ruolo: "Consigliere" },
      { nome: "Alfredo Catalfo", ruolo: "Consigliere" },
      { nome: "Michele Maria Cruciani", ruolo: "Consigliere" },
      { nome: "Gaja Girone", ruolo: "Consigliere" },
      { nome: "Gregorio Kedros", ruolo: "Consigliere" },
      { nome: "Alessandra Laterza", ruolo: "Consigliere" },
      { nome: "Rita Longhi", ruolo: "Consigliere" },
      { nome: "Maurizio Mecozzi", ruolo: "Consigliere" },
      { nome: "Paolo Nicoletti Altimare", ruolo: "Consigliere" },
      { nome: "Deborah Soria", ruolo: "Consigliere" },
      { nome: "Giulia Taccioli", ruolo: "Consigliere" },
      { nome: "Maria Grazia Umbro", ruolo: "Consigliere" },
    ],
    contatti: {
      referente: "Vanessa Tatini",
      indirizzo: "Via Marco e Marcelliano, 45 – 00147 Roma",
      email: "aliroma@confcommercioroma.it",
      tel: "06.68437235",
    },
  },

  {
    id: "apm",
    urlOriginale: "https://www.confcommercioroma.it/associazioni/apm-associazione-parcheggi-e-servizi-per-la-mobilita-urbana/",
    intro: [
      "APM è l'Associazione dei parcheggi e dei servizi per la mobilità: rappresenta e tutela le imprese che operano nel settore della gestione dei parcheggi, delle aree di sosta e dei servizi rivolti alla mobilità urbana.",
      "L'operato di APM è volto a coordinare e tutelare le azioni in difesa della categoria, promuovendo le attività di crescita e sviluppando le normative in accordo con gli Enti comunali, provinciali e regionali.",
      "APM si rende inoltre promotore dell'utilizzo di tecnologie innovative e di nuove soluzioni relative alle problematiche di settore, anche attraverso la collaborazione con altre Associazioni che hanno le stesse finalità.",
      "Puoi richiedere alla segreteria associativa la MODULISTICA predisposta per le imprese iscritte.",
    ],
    contatti: {
      referente: "Vincenza Civale",
      indirizzo: "Via Marco e Marcelliano, 45 – 00147 Roma",
      email: "apm@confcommercioroma.it",
      tel: "06.68437237",
    },
  },

  {
    id: "asfo",
    urlOriginale: "https://www.confcommercioroma.it/associazioni/asfo-sanita-lazio/",
    intro: [
      "AsFO Sanità Lazio si costituisce nel 1999 con l'intento di tutelare e rappresentare le Piccole e Medie Imprese che operano come fornitori di beni e servizi nel settore della Sanità, in tutte le aree del comparto, partendo dai dispositivi medici per arrivare ai servizi per la salute dei cittadini.",
      "AsFo Lazio è un punto di riferimento, a livello territoriale, per le aziende nei rapporti con gli Enti pubblici: intercetta le esigenze degli operatori del settore e ne diventa portavoce presso le istituzioni. Dal 2015 AsFo Lazio è entrata a far parte di FIFO Sanità (Federazione Italiana Fornitori in Sanità), realtà nazionale che raggruppa tutte le AsFo regionali.",
      "Tra le iniziative portate avanti da AsFo Lazio, una delle più identitarie è quella della cessione dei crediti sanitari, che con cadenza biennale coinvolge le imprese di settore.",
    ],
    presidente: {
      nome: "Sveva Belviso",
      foto: "https://www.confcommercioroma.it/wp-content/uploads/2021/12/SVEVA-BELVISO-300x180.png",
      bio: [
        "Sveva Belviso ricopre la carica di presidente AsFo Lazio da aprile 2023. Laureata in Psicologia Clinica alla Sapienza di Roma con 110 e lode, con specializzazione in psicodisagnostica e psicologia giuridica, inizia la sua attività come esperto nel Tribunale di Sorveglianza di Roma.",
        "La passione per la politica, unita a una formazione in discipline parlamentari, la porta a intraprendere un percorso che la porterà a ricoprire diverse cariche, tra cui quelle di Assessore alle Politiche Sociali e di Vicesindaco del Comune di Roma. A partire dal 2014 si dedica all'imprenditoria nel comparto sanitario, ricoprendo il ruolo di direttore generale di un'azienda del settore cardiovascolare.",
        "Il 15 dicembre 2023 è stata eletta presidente di FIFO, Federazione Italiana Fornitori Ospedalieri in Sanità.",
      ],
    },
    consiglio: [
      { nome: "Sveva Belviso", ruolo: "Presidente" },
      { nome: "Andrea Bonura", ruolo: "Vicepresidente" },
      { nome: "Simona Raggi", ruolo: "Vicepresidente" },
      { nome: "Valeria Agnelli", ruolo: "Consigliere" },
      { nome: "Stefano Broglia", ruolo: "Consigliere" },
      { nome: "Renato Nicoletti", ruolo: "Consigliere" },
      { nome: "Emanuele Silvestri", ruolo: "Consigliere" },
    ],
    contatti: {
      referente: "Vincenza Civale",
      indirizzo: "Via Marco e Marcelliano, 45 – 00147 Roma",
      email: "asfolazio@confcommercioroma.it",
      tel: "06.68437237",
    },
  },

  {
    id: "assintel",
    urlOriginale: "https://www.confcommercioroma.it/associazioni/assintel-roma-e-lazio/",
    intro: [
      "Assintel è l'associazione nazionale di riferimento delle imprese ICT e digitali di Confcommercio – Imprese per l'Italia. L'associazione rappresenta e tutela gli interessi delle imprese associate nei confronti delle istituzioni e del mercato.",
      "Assintel è presente su tutto il territorio nazionale e conta oltre 1.500 associati, che operano in una vasta gamma di settori: Information technology (sviluppo di software, hardware, e-commerce), Telecomunicazioni, Sicurezza informatica e Servizi digitali (cloud computing, big data).",
    ],
    serviziTitolo: "Servizi agli associati",
    servizi: [
      "Rappresentanza e tutela degli interessi presso le istituzioni e i tavoli di concertazione per lo sviluppo del settore ICT e digitale",
      "Networking: incontri territoriali, gruppi di lavoro tematici e portale associativo",
      "Aggiornamento: newsletter, analisi e ricerche di mercato, tariffe professionali IT, convegni e seminari",
      "Convenzioni per partecipare a fiere e manifestazioni di settore con forti sconti",
    ],
    presidente: {
      nome: "Alfredo Adamo",
      foto: "https://www.confcommercioroma.it/wp-content/uploads/2021/12/ADAMO-200x300.jpg",
      bio: [
        "Imprenditore e manager con 35 anni di esperienza nei settori ICT e Innovazione, con formazione in Italia e a Boston. Dal 2005 ad oggi ricopre ruoli di vertice (Amministratore Delegato) in società IT e di Consulenza Strategica nell'Innovazione. Esperto in gestione dell'Innovazione, scouting tecnologico e impatto dell'intelligenza artificiale su strategie aziendali.",
        "Dal 2013 come imprenditore guida Alan Advantage, uno dei Business Angel Investor più attivi in Italia nel mondo delle Startup, avendo selezionato e gestito oltre 30 investimenti. Nel 2018 ha cofondato l'associazione culturale Re:Humanism, che si occupa di favorire il dialogo tra umanisti e tecnologici dell'Artificial Intelligence. Dal 2023 è membro del Comitato Direttivo di Assintel e Coordinatore territoriale del Lazio.",
      ],
    },
    consiglio: [
      { nome: "Alfredo Adamo", ruolo: "Presidente" },
      { nome: "Andrea Capitani", ruolo: "Vicepresidente" },
      { nome: "Niccolò De Carlo", ruolo: "Consigliere" },
      { nome: "Emanuele Pecora", ruolo: "Consigliere" },
      { nome: "Luca Scuriatti", ruolo: "Consigliere" },
    ],
    contatti: {
      referente: "Filippo Aparo",
      indirizzo: "Via Marco e Marcelliano, 45 – 00147 Roma",
      email: "roma@assintel.it",
      tel: "06.68437.353",
    },
  },

  {
    id: "professioni",
    urlOriginale: "https://www.confcommercioroma.it/associazioni/confcommercio-professioni-roma/",
    intro: [
      "L'Associazione Territoriale Professioni Confcommercio Roma accoglie e rappresenta l'esercito delle partite IVA, dei lavoratori autonomi e dei freelance della Capitale e si coordina con l'operato dell'Associazione confederale di Confcommercio Professioni, con particolare attenzione alle istanze legate al contesto territoriale e con l'intenzione di favorire il confronto interdisciplinare e la creazione di nuovi servizi ed opportunità per rafforzare la capacità di operare dei nostri associati.",
      "A livello nazionale, la federazione Confcommercio Professioni ha lo scopo di rappresentare il lavoro autonomo professionale in diversi settori con l'obiettivo di tutelare, promuovere e valorizzare i professionisti in tutta Italia.",
      "\"I professionisti – secondo la presidente Anna Rita Fioroni – sono il settore più dinamico dell'occupazione perché hanno un ruolo centrale e crescente con il crescere del peso dei servizi. Per questo innanzitutto devono essere inclusi nelle misure di sostegno ed incentivazione per la competitività e la crescita.\"",
    ],
    presidente: {
      nome: "Anna Rita Fioroni",
      foto: "https://www.confcommercioroma.it/wp-content/uploads/2021/12/fioroni_annarita-300x217.jpg",
      bio: [
        "Attualmente avvocato, Anna Rita Fioroni ha lavorato con ruoli dirigenziali fino al 2008 presso il Gruppo Grandi Magazzini Fioroni Spa, realtà della Grande Distribuzione Organizzata del centro Italia.",
        "Senatrice dal 2008 al 2013 nella XVI legislatura, è stata membro della 10° Commissione permanente (Industria, Commercio, Turismo), della Commissione straordinaria per il controllo dei prezzi e del comitato per l'efficienza energetica del Senato.",
        "Associazione Territoriale Professioni Confcommercio Roma fa parte della omonima Federazione nazionale di cui Anna Rita Fioroni è già Presidente e ne interpreta le istanze sul territorio, oltre ad offrire servizi e favorire networking tra i professionisti associati.",
      ],
    },
    consiglio: [
      { nome: "Anna Rita Fioroni", ruolo: "Presidente" },
      { nome: "Clara Cairoli", ruolo: "Consigliere" },
      { nome: "Marco Di Stefano", ruolo: "Consigliere" },
      { nome: "Andrea Locatelli", ruolo: "Consigliere" },
      { nome: "Emanuele Montemarano", ruolo: "Consigliere" },
      { nome: "Tommaso Salvatori", ruolo: "Consigliere" },
      { nome: "Debora Valente", ruolo: "Consigliere" },
    ],
    contatti: {
      referente: "Vincenza Civale",
      indirizzo: "Via Marco e Marcelliano, 45 – 00147 Roma",
      email: "professioni@confcommercioroma.it",
      tel: "06.68437625",
    },
    video: {
      youtubeId: "20lDjaPXgwY",
      titolo: "Cosa significa avere una Partita IVA?",
      sezioneTitolo: "Webinar di Professioni Roma",
    },
    links: [
      { label: "Visita il sito di Confcommercio Professioni", url: "https://www.confcommercio.it/professioni", tipo: "external" },
      { label: "Scarica la brochure", url: "https://www.confcommercioroma.it/wp-content/uploads/2025/01/SCHEDA-PROFESSIONI_CONFCOMMERCIO_DIGITAL.pdf", tipo: "download" },
    ],
  },

  {
    id: "fida",
    urlOriginale: "https://www.confcommercioroma.it/associazioni/aprida/",
    intro: [
      "F.I.D.A. è la Federazione Italiana che rappresenta e tutela gli interessi degli operatori del commercio al dettaglio alimentare. La forte presenza dell'Associazione sul territorio, precedentemente denominata A.P.R.I.D.A., ha consentito di rispondere in maniera tempestiva alle problematiche connesse al mondo del piccolo dettaglio alimentare e, talvolta, ad indicarne le soluzioni.",
      "L'associazione offre una serie di servizi utili alla categoria: consulenza legale, commerciale e societaria; assistenza in materia di Sicurezza, Haccp e Privacy; formazione abilitante e obbligatoria; accesso al credito e garanzia fidi; redazione contratti, reclami, esposti e solleciti.",
    ],
    presidente: {
      nome: "Giuseppe Ligorio",
      foto: "https://www.confcommercioroma.it/wp-content/uploads/2021/12/FOTO-LIGORIO-260x300.jpg",
      bio: [
        "Giuseppe Ligorio, pugliese trapiantato a Roma da più di 20 anni, lavora come imprenditore ed ha maturato esperienze in diversi ed eterogenei settori: marketing territoriale, enogastronomia, sviluppo e innovazione, moda, sport, industria culturale, turismo, funds raising.",
        "È stato Amministratore Delegato di Duel e Generando, società di comunicazione e marketing con cui ha realizzato progetti per grandi e medie imprese italiane, imprese multinazionali ed ha collaborato con la pubblica amministrazione centrale ed enti locali per progetti di sviluppo locale e innovazione.",
        "Attualmente è Amministratore unico di Into'Sud, piattaforma di marketing territoriale e turismo enogastronomico esperienziale per la promozione delle eccellenze delle 8 Regioni del Sud Italia. Come presidente di F.I.D.A. rappresenta la salumeria La Tradizione di Via Cipro, Roma.",
      ],
    },
    consiglio: [
      { nome: "Giuseppe Ligorio", ruolo: "Presidente" },
      { nome: "Camilla Castroni", ruolo: "Vicepresidente" },
      { nome: "Ivano Daffina", ruolo: "Vicepresidente" },
      { nome: "Stefano Alibrandi", ruolo: "Consigliere" },
      { nome: "Virgilio Checchini", ruolo: "Consigliere" },
      { nome: "Luigi Focacci", ruolo: "Consigliere" },
      { nome: "Fabio Galli", ruolo: "Consigliere" },
      { nome: "Antonio Gamberoni", ruolo: "Consigliere" },
      { nome: "Giuseppe Giovale", ruolo: "Consigliere" },
      { nome: "Roberto Petrucci", ruolo: "Consigliere" },
    ],
    contatti: {
      referente: "Debora Scuccuglia",
      indirizzo: "Via Marco e Marcelliano, 45 – 00147 Roma",
      email: "fida@confcommercioroma.it",
      tel: "06.68437265",
    },
  },

  {
    id: "fima",
    urlOriginale: "https://www.confcommercioroma.it/associazioni/fimaroma/",
    intro: [
      "F.I.M.A. Roma è l'Associazione Territoriale della Federazione Italiana Mercanti d'Arte Confcommercio Roma che opera sul territorio di Roma e Provincia.",
      "FIMA Roma, insieme a FIMA Nazionale e a Confcommercio Imprese per l'Italia, difende gli interessi del commercio dell'arte e del mondo dell'antiquariato, e dialoga costantemente con Istituzioni ed Amministrazioni pubbliche e private, al fine di affrontare e definire tematiche di carattere artistico, imprenditoriale, sociale ed economico a nome dell'intera categoria.",
      "La Federazione promuove e sostiene la crescita delle proprie aziende e tutela le esigenze della categoria degli antiquari.",
    ],
    consiglio: [
      { nome: "Stefano Verdini", ruolo: "Presidente" },
      { nome: "Francesca Antonacci", ruolo: "Vicepresidente" },
      { nome: "Antonio Fratangeli", ruolo: "Consigliere" },
      { nome: "Gianluca Berardi", ruolo: "Consigliere" },
      { nome: "Gennaro Berger", ruolo: "Consigliere" },
    ],
    contatti: {
      indirizzo: "Via Marco e Marcelliano, 45 – 00147 Roma",
      email: "info@confcommercioroma.it",
      tel: "0668437625",
    },
  },

  {
    id: "fimaa",
    urlOriginale: "https://www.confcommercioroma.it/associazioni/fimaa-roma/",
    intro: [
      "FIMAA ROMA è l'Associazione dei professionisti del settore immobiliare di Roma e provincia. Questa grande e antica associazione rappresenta un'ampia gamma di professionisti che operano nel settore degli immobili, tra cui agenti immobiliari, mediatori creditizi, mediatori merceologici, agenti in attività finanziaria e agenti di servizi vari.",
      "FIMAA ROMA mantiene un'impeccabile attenzione ai suoi associati, offrendo costanti aggiornamenti del settore e servizi di valore.",
      "L'Associazione ha inoltre collaborato alla creazione dell'unico Corso di Laurea triennale in Italia \"Diritto ed Economia della proprietà immobiliare\" presso la Facoltà di Giurisprudenza dell'Università di Roma La Sapienza.",
    ],
    serviziTitolo: "Servizi offerti",
    servizi: [
      "Assicurazione professionale obbligatoria",
      "Customer care e aggiornamento professionale costante sulle novità legislative in materia immobiliare",
      "Consulenze immobiliari in materia legale, commerciale, societaria e contrattualistica",
      "Accesso a modelli contrattuali in 4 lingue",
      "Programmi di formazione continua",
      "Innovazione attraverso la condivisione del portafoglio e il Portale immobiliare",
      "Convegni per approfondire i temi di attualità del settore",
    ],
    presidente: {
      nome: "Maurizio Pezzetta",
      foto: "https://www.confcommercioroma.it/wp-content/uploads/2021/12/MAURIZIO-PEZZETTA.png",
      bio: [
        "Maurizio Pezzetta, nato a Roma il 01/01/1958, è un agente immobiliare e consulente con oltre 45 anni di esperienza nel settore. Attualmente è l'Amministratore de La Commerciale Srl Promozioni Immobiliari. Ha avuto una collaborazione esclusiva con Sotheby's International Realty per circa quindici anni fino al 2004, quando è diventato ufficialmente Exclusive Affiliate di Christie's International Real Estate fino al 2021.",
        "Membro fondatore di Italian Network Realty e EREN Ltd (European Real Estate Network), ricopre importanti incarichi come Vice Presidente Vicario della FIMAA Italia, Vice Presidente Vicario di Confcommercio Roma, Presidente della FIMAA Roma, FIMAA Lazio e Vice Presidente FIABCI Italia.",
        "Ha ottenuto la Certificazione di Qualità UNI EN ISO 9001:2015 da RINA. Nel 2013 è stato nominato Cavaliere del Commercio dal Sindaco di Roma.",
      ],
    },
    consiglio: [
      { nome: "Maurizio Pezzetta", ruolo: "Presidente" },
      { nome: "Maurizio Iori", ruolo: "Vicepresidente vicario" },
      { nome: "Gian Luca Sondali", ruolo: "Vicepresidente" },
      { nome: "Valerio Angeletti", ruolo: "Past President" },
      { nome: "Patrizia Bacciu", ruolo: "Consigliere" },
      { nome: "Marco Barile", ruolo: "Consigliere" },
      { nome: "Gianmichele Bragagnini", ruolo: "Consigliere" },
      { nome: "Massimiliano Chiapperi", ruolo: "Consigliere" },
      { nome: "Giuseppe Ciocci", ruolo: "Consigliere" },
      { nome: "Stefano Filastò", ruolo: "Consigliere" },
      { nome: "Marco Franceschini", ruolo: "Consigliere" },
      { nome: "Ada Gay", ruolo: "Consigliere" },
      { nome: "Pasquale Pennisi", ruolo: "Consigliere" },
      { nome: "Simone Pini", ruolo: "Consigliere" },
      { nome: "Marco Rognini", ruolo: "Consigliere" },
      { nome: "Raoul Sarghini", ruolo: "Consigliere" },
      { nome: "Armando Vitali", ruolo: "Consigliere" },
    ],
    contatti: {
      referente: "Manuela Del Vecchio",
      indirizzo: "Via Marco e Marcelliano, 45 – 00147 Roma",
      email: "fimaa.roma@confcommercioroma.it",
      tel: "06.68437204",
    },
    links: [
      { label: "Visita il sito ufficiale", url: "http://www.fimaaroma.it/", tipo: "external" },
      { label: "Scarica la brochure", url: "https://www.confcommercioroma.it/wp-content/uploads/2025/01/Scheda_FIMAA_070324.pdf", tipo: "download" },
    ],
  },

  {
    id: "fedagro",
    urlOriginale: "https://www.confcommercioroma.it/associazioni/fedagro-mercati-roma/",
    intro: [
      "Fedagromercati Roma – Confcommercio è l'Associazione provinciale che rappresenta gli operatori grossisti ortofrutticoli all'interno del Centro Agroalimentare di Roma ScpA, una delle più importanti strutture europee e polo logistico import ed export, organizzato e tecnologicamente avanzato per la commercializzazione dei prodotti ortofrutticoli ed ittici.",
      "Fedagromercati Roma tutela gli interessi delle imprese e la dignità di imprenditori degli operatori di categoria, promuove attività di formazione, sviluppo e supporto per la filiera agroalimentare, favorisce lo spirito associazionistico fra le imprese e offre servizi specifici per la categoria.",
    ],
    presidente: {
      nome: "Luigi Cofone",
      foto: "https://www.confcommercioroma.it/wp-content/uploads/2021/12/LUIGI-COFONE-300x219.png",
      bio: [
        "Classe 68, imprenditore di successo nel mondo della logistica romana, attualmente è Amministratore della Consetra Logistica Srl, azienda da lui creata dopo una lunga esperienza nel settore. L'azienda si è consolidata quale leader nella logistica e il trasporto all'interno del Centro Agroalimentare di Roma e nel resto d'Italia.",
        "Riconosciuto nel settore, da molti anni Luigi Cofone è parte integrante del CDA del Centro Agroalimentare di Roma ScpA e partecipa con responsabilità alle decisioni riguardanti l'importante filiera alimentare.",
      ],
    },
    consiglio: [
      { nome: "Luigi Cofone", ruolo: "Presidente" },
      { nome: "Riccardo Pompei", ruolo: "Vicepresidente" },
      { nome: "Valter Arcangeli", ruolo: "Consigliere" },
      { nome: "Luigi Molitierno", ruolo: "Consigliere" },
      { nome: "Mirko Caccia", ruolo: "Consigliere" },
      { nome: "Massimo Visconti", ruolo: "Consigliere" },
    ],
    contatti: {
      referente: "Sara Iannelli",
      indirizzo: "Via Marco e Marcelliano, 45 – 00147 Roma | Sede operativa: C/o CAR Guidonia Montecelio",
      email: "fedagromercatiroma@confcommercioroma.it",
      tel: "06.60503130",
    },
    links: [
      { label: "Sito Nazionale", url: "https://www.fedagromercati.it/category/roma/", tipo: "external" },
    ],
  },

  {
    id: "moda-italia",
    urlOriginale: "https://www.confcommercioroma.it/associazioni/federazione-moda-italia-roma/",
    intro: [
      "FEDERAZIONE MODA ITALIA ROMA è l'Associazione di categoria che rappresenta e tutela gli interessi professionali e sindacali delle attività commerciali al dettaglio e all'ingrosso operanti nei settori di moda, abbigliamento, calzature, tessile per arredamento, tessuti per abbigliamento, pelletterie, accessori, articoli sportivi.",
      "La Federazione favorisce le relazioni fra gli associati per lo studio e la risoluzione dei problemi di comune interesse.",
    ],
    consiglio: [
      { nome: "Massimo Bertoni", ruolo: "Presidente" },
      { nome: "Grazia Marino", ruolo: "Vicepresidente" },
      { nome: "Robert Sassun", ruolo: "Consigliere" },
      { nome: "Daniela Di Francesco", ruolo: "Consigliere" },
    ],
    contatti: {
      indirizzo: "Via Marco e Marcelliano, 45 – 00147 Roma",
      email: "federmoda@confcommercioroma.it",
      tel: "06.68437620",
    },
  },

  {
    id: "federpreziosi",
    urlOriginale: "https://www.confcommercioroma.it/associazioni/federpreziosi-roma/",
    intro: [
      "FEDERPREZIOSI ROMA rappresenta le imprese orafe, gioielliere, argentiere ed orologiaie associate di Roma e provincia.",
      "Federpreziosi Roma tutela e valorizza gli interessi sindacali, economici e giuridici di tutte le categorie del mondo orafo, dai commercianti al dettaglio ai distributori all'ingrosso, ai fabbricanti, agli artigiani, ai rappresentanti.",
      "L'Associazione difende gli interessi dei soci presso le istituzioni capitoline, partecipa ai tavoli tecnici, promuove e favorisce servizi di consulenza e assistenza specifica per i soci. Realizza un'intensa attività formativa a livello territoriale con un programma di PCTO nei diversi istituti superiori di Roma e Provincia e con un importante accordo con l'Università degli Studi di Roma La Sapienza.",
    ],
    contatti: {
      referente: "Vanessa Tatini",
      indirizzo: "Via Marco e Marcelliano, 45 – 00147 Roma",
      email: "federpreziosiroma@confcommercioroma.it",
      tel: "06.68437235",
    },
    links: [
      { label: "Scarica la presentazione", url: "https://www.confcommercioroma.it/wp-content/uploads/2022/11/FEDERPREZIOSI-ROMA-PRESENTAZIONE.pdf", tipo: "download" },
    ],
  },

  {
    id: "federservizi",
    urlOriginale: "https://www.confcommercioroma.it/associazioni/federservizi/",
    intro: [
      "FederServizi è l'associazione di categoria che rappresenta le imprese, le organizzazioni imprenditoriali e gli operatori economici che operano nel settore dei servizi e del terziario avanzato.",
    ],
    serviziTitolo: "Servizi agli associati",
    servizi: [
      "Rappresentanza e tutela degli interessi nei confronti delle istituzioni, del territorio e del mercato",
      "Formazione e aggiornamento: organizzazione di eventi formativi per migliorare le competenze degli associati",
      "Assistenza e consulenza in materia di diritto, fiscalità, lavoro e sicurezza",
    ],
    presidente: {
      nome: "Camillo Ricci",
      foto: "https://www.confcommercioroma.it/wp-content/uploads/2021/12/cCAMILLO-RICCI-300x267.png",
      bio: [
        "Trent'anni di esperienza nella comunicazione pubblica e istituzionale, è Amministratore delegato di Eprcomunicazione spa, società quotata a EGM, e Presidente di Justbit, digital factory del Gruppo.",
        "Giornalista professionista, è stato portavoce e consulente per la comunicazione di organismi politici e istituzionali (Ministero della Difesa, degli Affari esteri e dello Sviluppo economico). Ha diretto la comunicazione del Forum della Pubblica Amministrazione e gestito numerosi dossier relativi a crisi internazionali.",
        "È docente della Business School del Sole 24 ore nel master Comunicazione d'Impresa, Lobbying e Relazioni Internazionali. Dal 2021 è Presidente di Federservizi e vice presidente di Confcommercio Roma.",
      ],
    },
    consiglio: [
      { nome: "Camillo Ricci", ruolo: "Presidente" },
      { nome: "Marco Benucci", ruolo: "Vicepresidente" },
      { nome: "Pierluigi Ascani", ruolo: "Consigliere" },
      { nome: "Danilo Cattaneo", ruolo: "Consigliere" },
      { nome: "Flaminia Fazi", ruolo: "Consigliere" },
      { nome: "Andrea Gallo", ruolo: "Consigliere" },
      { nome: "Giuseppe Ligorio", ruolo: "Consigliere" },
      { nome: "Federico Nicolai", ruolo: "Consigliere" },
      { nome: "Lorenzo Pellegrini", ruolo: "Consigliere" },
      { nome: "Simona Petrozzi", ruolo: "Consigliere" },
      { nome: "Pasquale Sperlenga", ruolo: "Consigliere" },
      { nome: "Giuseppe Sappa", ruolo: "Consigliere" },
      { nome: "Alessandro Muller", ruolo: "Consigliere" },
      { nome: "Gaetano Grasso", ruolo: "Consigliere" },
    ],
    contatti: {
      referente: "Filippo Aparo",
      indirizzo: "Via Marco e Marcelliano, 45 – 00147 Roma",
      email: "federservizi@confcommercioroma.it",
      tel: "06.68437.353",
    },
  },

  {
    id: "fipe",
    urlOriginale: "https://www.confcommercioroma.it/associazioni/fipe-confcommercio-roma/",
    intro: [
      "FIPE ROMA è l'associazione di categoria dei pubblici esercizi che operano sul territorio di Roma e provincia.",
      "La Federazione Italiana Pubblici Esercizi di Roma rappresenta e tutela gli interessi professionali, sindacali e commerciali di bar, ristoranti, pizzerie, gelaterie, pasticcerie, discoteche, stabilimenti balneari, sale gioco ma anche aziende di ristorazione collettiva e di catering e banqueting.",
      "In riferimento al settore dei pubblici esercizi, il bacino imprenditoriale della città metropolitana di Roma è uno dei più grandi del Paese. Proprio per questo l'associazione si impegna a dare voce alle istanze e ai bisogni delle imprese associate e le rappresenta presso le istituzioni locali con l'obiettivo di valorizzare il contributo fondamentale che il settore dà alla crescita economica e sociale della Capitale.",
    ],
    serviziTitolo: "Servizi agli associati",
    servizi: [
      "Consulenza legale, commerciale e societaria",
      "Assistenza in materia di Sicurezza, HACCP e Privacy",
      "Formazione abilitante e obbligatoria",
      "Accesso al credito e garanzia fidi",
      "Redazione contratti, reclami, esposti e solleciti",
      "Rappresentanza istituzionale presso le istituzioni locali",
    ],
    presidente: {
      nome: "Sergio Paolantoni",
      foto: "https://www.confcommercioroma.it/wp-content/uploads/2021/12/Sergio-Paolantoni-300x300.jpeg",
      bio: [
        "Sergio Paolantoni. Classe 1960. Imprenditore di successo nel mondo della ristorazione romana, attualmente è il Presidente della Palombini Eur srl, azienda di famiglia fondata nel 1963 dal Commendatore Giovanni Palombini.",
        "Negli anni 80 inizia la gestione delle attività di famiglia consolidando il business storico e creando la divisione catering e banqueting. Il Gruppo Palombini, sotto la sua guida, gestisce servizi caffetteria e catering per istituzioni prestigiose come il Museo MAXXI e l'Università Luiss Guido Carli. È noto per organizzare servizi ristorativi per eventi sportivi di rilievo, come il Concorso Ippico di Piazza di Siena e il Campionato internazionale Sei Nazioni Rugby.",
        "Riconosciuto nel settore, è stato nominato Consigliere di importanti organizzazioni come Assobar di Roma e provincia e la Confcommercio di Roma e del Lazio. Nel 2003 ha ottenuto il titolo di Cavaliere del Commercio di Roma e attualmente ricopre il ruolo di Vice Presidente di Confcommercio Roma e Vice Presidente di Fipe-Confcommercio.",
      ],
    },
    video: {
      youtubeId: "aOl7SWABTjU",
      titolo: "SERGIO PAOLANTONI | Presidente FIPE Roma",
      sezioneTitolo: "Video",
    },
    consiglio: [
      { nome: "Sergio Paolantoni", ruolo: "Presidente, Vice Presidente Confcommercio Roma e Vice Presidente di Fipe-Confcommercio" },
      { nome: "Antonio Flamini", ruolo: "Vicepresidente" },
      { nome: "Angelo Giraldi", ruolo: "Vicepresidente" },
      { nome: "Valeria Strappini", ruolo: "Vicepresidente" },
      { nome: "Andrea Azzarone", ruolo: "Giunta" },
      { nome: "Giorgio Catalano", ruolo: "Giunta" },
      { nome: "Daniele Aprile", ruolo: "Consigliere" },
      { nome: "Benedetto Bedussa", ruolo: "Consigliere" },
      { nome: "Matteo Berio", ruolo: "Consigliere" },
      { nome: "Vincenzo Alfredo Colao", ruolo: "Consigliere" },
      { nome: "Fabrizio De Mauro", ruolo: "Consigliere" },
      { nome: "Andrea Fassi", ruolo: "Consigliere" },
      { nome: "Daniela Gazzini", ruolo: "Consigliere" },
      { nome: "Lorenzo Lisi", ruolo: "Consigliere" },
      { nome: "Fabiano Lofaro", ruolo: "Consigliere" },
      { nome: "Edoardo Moscara", ruolo: "Consigliere" },
      { nome: "Alessandro Pipero", ruolo: "Consigliere" },
      { nome: "Fabrizio Santucci", ruolo: "Consigliere" },
    ],
    contatti: {
      referente: "Debora Scuccuglia",
      email: "fipe@confcommercioroma.it",
      tel: "06.68437265 – 06.68437605",
    },
    links: [
      { label: "Sito Nazionale", url: "http://www.fipe.it/", tipo: "external" },
      { label: "Sfoglia la brochure", url: "https://www.confcommercioroma.it/wp-content/uploads/2025/01/FIPE_SCHEDA_03102024.pdf", tipo: "download" },
    ],
  },

  {
    id: "fiva",
    urlOriginale: "https://www.confcommercioroma.it/associazioni/fiva-roma/",
    intro: [
      "La Federazione Italiana Venditori Ambulanti (FIVA Confcommercio Roma) tutela gli interessi sociali, materiali ed economici degli operatori del commercio su area pubblica e rappresenta, con un puntuale impegno sindacale, le istanze della categoria di fronte alle istituzioni capitoline e municipali.",
      "Promuove la qualificazione e la formazione imprenditoriale e professionale degli ambulanti, fornisce servizi utili alla categoria e punta a ripensare e a rappresentare un'eccellenza per l'intero settore.",
    ],
    presidente: {
      nome: "Valter Papetti",
      foto: "https://www.confcommercioroma.it/wp-content/uploads/2021/12/Roadshow_21.06-9997-scaled.jpg",
      bio: [
        "Valter Papetti dal 2019 ricopre la carica di Presidente di FIVA Confcommercio Roma. È inoltre uno dei Vicepresidenti della Federazione Nazionale e Presidente della Cooperativa Centro Commerciale Laurentino, che si occupa di gestire i servizi comuni in convenzione del Mercato Laurentino e il relativo parcheggio.",
        "La passione per il commercio su area pubblica comincia nel 1975 quando inizia a lavorare ai Mercati Generali per la ditta all'ingrosso dello zio. Nel 1989 decide di avviare la sua attività e acquista un banco al Mercato Laurentino; due anni dopo diventa Presidente della Cooperativa del Mercato.",
      ],
    },
    consiglio: [
      { nome: "Valter Papetti", ruolo: "Presidente" },
      { nome: "Alessandro Nencini", ruolo: "Consigliere" },
      { nome: "Corrado Vitale", ruolo: "Consigliere" },
      { nome: "Massimiliano Castelletti", ruolo: "Consigliere" },
      { nome: "Marco Vagaggini", ruolo: "Consigliere" },
      { nome: "Carlo Collalti", ruolo: "Consigliere" },
      { nome: "Luca Vernarecci", ruolo: "Consigliere" },
      { nome: "Eliseo Franzese", ruolo: "Consigliere" },
    ],
    contatti: {
      referente: "Cecilia Martorana",
      indirizzo: "Via Marco e Marcelliano, 45 – 00147 Roma",
      email: "fivaroma@confcommercioroma.it",
      tel: "06 68437265",
    },
  },

  // ── ASSOCIAZIONI ADERENTI ────────────────────────────────────────────

  {
    id: "rinascita",
    urlOriginale: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/associazioni-aderenti/rinascita-imprese/",
    intro: [
      "L'Associazione Rinascita Imprese nasce il 7 dicembre 2022 dalla fusione ideale delle precedenti esperienze dell'Associazione Commercianti di Velletri e l'AIV, l'Associazione Imprenditori di Velletri. Entrambe sono state il supporto di imprenditrici e imprenditori, storicamente impegnate nel sostegno e sviluppo delle attività commerciali del territorio. La nuova denominazione rappresenta una concreta e sostanziale trasformazione delle precedenti associazioni, che delinea il nuovo spirito associativo.",
      "Rinascita Imprese è stata fondata con l'obiettivo di favorire attività imprenditoriali in linea con le nuove opportunità offerte dall'innovazione tecnologica e sostenibile, in grado di sviluppare progetti comuni, reti di imprese e consorzi. Stare insieme, il lavoro di squadra, l'amicizia tra imprenditori sono valori fondanti che si ripetono nelle molteplici iniziative portate avanti dall'associazione.",
      "Rinascita Imprese si pone come volano per incentivare la crescita e la formazione di imprenditrici ed imprenditori organizzando incontri, corsi e appuntamenti socio-culturali in tutto il territorio dei Castelli Romani. Particolare attenzione è rivolta al sostegno dell'imprenditoria femminile. Dal 28 febbraio 2024, con l'adesione a Confcommercio Roma, l'associazione ha compiuto un'ulteriore crescita. È guidata dal Presidente Pietro Sportelli.",
    ],
    consiglio: [
      { nome: "Pietro Sportelli", ruolo: "Presidente" },
      { nome: "Nando Mastrostefano", ruolo: "Consigliere" },
      { nome: "Paolo Pietrosanti", ruolo: "Consigliere" },
      { nome: "Stefano Cioccari", ruolo: "Consigliere" },
      { nome: "Fabio Casu", ruolo: "Consigliere" },
      { nome: "Massimiliano Picca", ruolo: "Consigliere" },
      { nome: "Igino Bizzoni", ruolo: "Consigliere" },
      { nome: "Alessandro Micheli", ruolo: "Consigliere" },
      { nome: "Alberto Galli", ruolo: "Consigliere" },
    ],
    contatti: {
      indirizzo: "Via di Cori 14 d – 00049 Velletri Roma",
      tel: "342 08 04 197",
      email: "info@rinascitaimprese.it",
      sito: "http://www.rinascitaimprese.it/",
      sitoLabel: "www.rinascitaimprese.it",
    },
  },

  {
    id: "confederazione-sport",
    urlOriginale: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/associazioni-aderenti/confederazione-dello-sport/",
    intro: [
      "La Confederazione dello Sport rappresenta l'associazione di categoria del mondo sportivo, dei gestori degli operatori di attività sportive, del tempo libero, del benessere, delle attività ludico-ricreative, dei gestori degli impianti sportivi, dei lavoratori autonomi sportivi nonché delle professioni in ambito sportivo.",
      "È il punto di riferimento e di rappresentanza per coniugare le esigenze dell'imprenditoria sportiva, degli operatori nel settore no profit nonché delle professioni in ambito sportivo di cui alla direttiva 2013/55/UE.",
    ],
    contatti: {
      indirizzo: "Via Reno, 30 – 00198 Roma",
      tel: "+39 06 88 48 874",
      email: "segreteria@confederazionedellosport.it",
      sito: "http://www.confederazionedellosport.it/",
      sitoLabel: "www.confederazionedellosport.it",
    },
  },

  {
    id: "fiavet",
    urlOriginale: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/associazioni-aderenti/fiavet-lazio/",
    intro: [
      "Fiavet Lazio, Associazione delle Imprese del Turismo, rappresenta e tutela gli interessi in campo politico, economico, giuridico e sindacale delle Imprese turistiche della Regione Lazio: Agenzie di Viaggi, Tour Operator di incoming, outgoing, incentive e congressi.",
      "L'Associazione collabora e si confronta con istituzioni nazionali, regionali e associazioni varie per uno sviluppo sempre maggiore del sistema turistico locale e per la condivisione delle strategie politiche del Turismo nella Regione.",
    ],
    consiglio: [
      { nome: "Stefano Corbari", ruolo: "Presidente" },
      { nome: "Teresa Amuro", ruolo: "Consigliere" },
      { nome: "Fabio Benedetti", ruolo: "Consigliere" },
      { nome: "Stefano Capoccioni", ruolo: "Consigliere" },
      { nome: "Cristina Compagno", ruolo: "Consigliere" },
      { nome: "Luana De Angelis", ruolo: "Consigliere" },
      { nome: "Giancarlo Iacuitto", ruolo: "Consigliere" },
      { nome: "Daniele Mazzi", ruolo: "Consigliere" },
      { nome: "Diletta Petrucci", ruolo: "Consigliere" },
      { nome: "Maria Luisa Porciatti", ruolo: "Consigliere" },
      { nome: "Carlo Terracciano", ruolo: "Consigliere" },
    ],
    contatti: {
      indirizzo: "Via Chiana, 38 – 00198 Roma",
      tel: "+39 06 4885051 – +39 06 42884881",
      email: "info@fiavet.lazio.it",
      sito: "https://www.fiavet.lazio.it/",
      sitoLabel: "www.fiavet.lazio.it",
    },
  },

  {
    id: "federalberghi",
    urlOriginale: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/associazioni-aderenti/federalberghi-roma/",
    intro: [
      "Federalberghi Roma è l'associazione di categoria degli albergatori di Roma e Provincia che rappresenta e tutela gli interessi e le istanze della categoria stessa nei confronti delle Pubbliche Istituzioni.",
      "Quale associazione maggiormente rappresentativa della categoria a livello territoriale, garantisce agli alberghi associati assistenza e tutela qualificata con riferimento a tutto ciò che concerne la gestione alberghiera.",
      "Offre inoltre consulenze qualificate su tutte le materie di possibile interesse per la gestione della propria attività grazie a professionisti di comprovata esperienza in campo alberghiero.",
    ],
    contatti: {
      indirizzo: "Corso d'Italia, 19 – 00198 Roma",
      tel: "+39 068414105",
      email: "info@federalberghiroma.it",
      sito: "https://roma.federalberghi.it/index.aspx",
      sitoLabel: "roma.federalberghi.it",
    },
  },

  {
    id: "anec",
    urlOriginale: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/associazioni-aderenti/anec-lazio/",
    intro: [
      "L'ANEC Lazio (Associazione regionale Lazio esercenti cinema) è l'associazione di categoria dell'esercizio cinematografico regionale nata nel 1954.",
      "L'associazione si propone di tutelare gli interessi e rappresentare gli esercenti cinema della regione nei confronti delle Istituzioni, del Governo centrale, dei Ministeri competenti e degli Enti Locali, delle altre associazioni imprenditoriali e sindacali.",
    ],
    contatti: {
      indirizzo: "Via Vicenza, 5/a – 00185 Roma",
      tel: "+39 06 4451 208 / +39 06 4451 290",
      email: "anec@agisanec.lazio.it",
      sito: "http://www.aneclazio.com/",
      sitoLabel: "www.aneclazio.com",
    },
  },

  {
    id: "teatri-roma",
    urlOriginale: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/associazioni-aderenti/unione-teatri-di-roma/",
    intro: [
      "L'Associazione UTR, Unione Teatri di Roma, riunisce le imprese, persone fisiche ed enti associativi esercenti attività di spettacolo, in ambito nazionale ed estero.",
      "Tra i suoi ambiti di attività, si pone come obiettivo affermare e promuovere la funzione pubblica e sociale del teatro privato, favorire una corretta modalità di conduzione e gestione di imprese ed associazioni operanti nel mondo dello spettacolo e incentivare la qualificazione professionale e la progettualità artistica degli associati.",
    ],
    contatti: {
      sito: "https://www.unioneteatriroma.it/",
      sitoLabel: "www.unioneteatriroma.it",
    },
  },

  {
    id: "assopetroli",
    urlOriginale: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/associazioni-aderenti/assopetroli-assoenergia/",
    intro: [
      "Assopetroli è l'associazione che rappresenta le imprese attive nei settori del commercio all'ingrosso dei prodotti petroliferi, commercio al dettaglio di carburanti, servizi per il risparmio e l'efficienza energetica degli impianti di climatizzazione e logistica petrolifera.",
      "Favorisce la trasformazione delle imprese associate nel lungo percorso che ha visto imporsi l'innovazione dei prodotti e la diversificazione delle fonti energetiche e sostiene le imprese nella sfida dell'efficienza energetica e del rispetto dell'ambiente.",
    ],
    contatti: {
      indirizzo: "Via San Martino della Battaglia 25 – 00185 Roma",
      tel: "066861505",
      email: "info@assopetroli.it",
      sito: "https://www.assopetroli.it/",
      sitoLabel: "www.assopetroli.it",
    },
  },

  // ── GRUPPI TRASVERSALI ───────────────────────────────────────────────

  {
    id: "impresa-cultura",
    urlOriginale: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/gruppi-trasversali/coordinamento-impresa-cultura-confcommercio-roma/",
    intro: [
      "Il Coordinamento \"Impresa Cultura – Confcommercio Roma\" riunisce Associazioni che operano, anche in via non esclusiva, nei settori della cultura, dello spettacolo, dell'intrattenimento e della creatività.",
    ],
    serviziTitolo: "Finalità del Coordinamento",
    servizi: [
      "Porsi come interlocutore nei confronti di Istituzioni, Enti e Organismi competenti per le tematiche legate al settore della cultura, dello spettacolo, dell'intrattenimento e della creatività",
      "Promuovere progetti e iniziative trasversali utili a valorizzare il binomio turismo e cultura",
      "Favorire la crescita di tutti gli attori della filiera della Cultura e dei settori indirettamente interessati",
    ],
    presidente: {
      nome: "Valerio Toniolo",
      bio: [
        "Il Dott. Valerio Toniolo presiede il Coordinamento \"Impresa Cultura – Confcommercio Roma\", coadiuvato da un Comitato Tecnico ristretto che riunisce diverse Associazioni.",
      ],
    },
    contatti: {
      indirizzo: "Via Marco e Marcelliano, 45 – 00147 Roma",
      tel: "06.68437500",
      email: "info@confcommercioroma.it",
    },
  },

  {
    id: "terziario-donna",
    urlOriginale: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/gruppi-trasversali/terziario-donna-roma/",
    intro: [
      "Il Gruppo Terziario Donna Confcommercio Roma, formato da imprenditrici e libere professioniste, offre servizi di assistenza, consulenza, formazione, informazione e approfondimento a tutte le donne, imprenditrici o aspiranti tali e libere professioniste che necessitano di supporto per muoversi nel mercato del lavoro e dell'imprenditoria a Roma e Provincia.",
      "Confcommercio Roma e il Gruppo Terziario Donna Confcommercio Roma da anni promuovono una rilettura delle dinamiche di mercato e nuove visioni di economia efficace. Il terziario di mercato, ed in particolare le imprese femminili, possono fare da guida per lo sviluppo di un modello rigenerativo di creazione di valore economico, sociale e ambientale.",
      "Il Gruppo Terziario Donna Roma supporta una classe imprenditoriale sostenibile, etica, innovativa. Lavora concretamente per l'empowerment femminile e la cultura d'impresa per abbattere concretamente gli squilibri, anche familiari, che condizionano negativamente il benessere e lo sviluppo delle donne.",
    ],
    presidente: {
      nome: "Simona Petrozzi",
      foto: "https://www.confcommercioroma.it/wp-content/uploads/2024/01/simona-petrozzi-214x300.png",
      bio: [
        "Nasce a Roma, divorziata con un figlio di 19 anni. Figlia di imprenditore nel settore delle costruzioni, dopo un'esperienza giovanile di 10 anni nel mondo dei media e TV si è laureata in Lingue e Letterature Straniere con indirizzo \"Comunicazione-Informazione\". Grazie alla conoscenza di 5 lingue, ha gestito rapporti istituzionali, politici e aziendali, specializzandosi in consulenza aziendale, innovazione e servizi alle imprese.",
        "Nel Marzo 2005 è nominata \"Consulente per le attività internazionali\" del Capo di Gabinetto del Ministro delle Comunicazioni. Nel 2006 fonda la SIRO Consulting, azienda di comunicazione digitale e Web Reputation. Dal 2011 al 2015 è stata Vicepresidente Nazionale del \"Gruppo Giovani Imprenditori Confcommercio\" e Delegata Nazionale alla Legalità.",
        "Dal Gennaio 2019 è Presidente di \"Terziario Donna Confcommercio Roma\" e dal Maggio 2022 è Vicepresidente Nazionale di Terziario Donna Confcommercio. Nel Luglio 2024 è stata nominata Presidente del Comitato Imprenditoria Femminile della Camera di Commercio di Roma.",
      ],
    },
    consiglio: [
      { nome: "Simona Petrozzi", ruolo: "Presidente" },
      { nome: "Tiziana Volpes", ruolo: "Vicepresidente" },
      { nome: "Caterina Flick", ruolo: "Vicepresidente" },
      { nome: "Maria Eugenia Albè", ruolo: "Consigliera" },
      { nome: "Patrizia Bacciu", ruolo: "Consigliera" },
      { nome: "Francesca Bizzoni", ruolo: "Consigliera" },
      { nome: "Dulce Casadiego", ruolo: "Consigliera" },
      { nome: "Alessandra Cattel", ruolo: "Consigliera" },
      { nome: "Elisa D'Arrigo", ruolo: "Consigliera" },
      { nome: "Luana De Angelis", ruolo: "Consigliera" },
      { nome: "Laura De Chiara", ruolo: "Consigliera" },
      { nome: "Antonella De Gregorio", ruolo: "Consigliera" },
      { nome: "Sabrina Fattori", ruolo: "Consigliera" },
      { nome: "Silvia Favulli", ruolo: "Consigliera" },
      { nome: "Alice Ferranti", ruolo: "Consigliera" },
      { nome: "Lavinia Ferrari", ruolo: "Consigliera" },
      { nome: "Fabiana Flecchia", ruolo: "Consigliera" },
      { nome: "Pina Foti", ruolo: "Consigliera" },
      { nome: "Cristina Gregori", ruolo: "Consigliera" },
      { nome: "Antonella Lombardi", ruolo: "Consigliera" },
      { nome: "Annamaria Malgioglio", ruolo: "Consigliera" },
      { nome: "Eloisa Manfredi", ruolo: "Consigliera" },
      { nome: "Marina Marconato", ruolo: "Consigliera" },
      { nome: "Monica Menichelli", ruolo: "Consigliera" },
      { nome: "Chiara Montaldi", ruolo: "Consigliera" },
      { nome: "Paola Pisani", ruolo: "Consigliera" },
      { nome: "Roberta Porreca", ruolo: "Consigliera" },
      { nome: "Cristina Riva", ruolo: "Consigliera" },
      { nome: "Adriana Soares", ruolo: "Consigliera" },
      { nome: "Federica Verre", ruolo: "Consigliera" },
    ],
    contatti: {
      referente: "Enrica Martini",
      indirizzo: "Via Marco e Marcelliano, 45 – 00147 Roma",
      tel: "06.68437605",
      email: "terziariodonna@confcommercioroma.it",
    },
    video: {
      youtubeId: "5RJv4buyf2I",
      titolo: "Terziario Donna Roma · RAI 3 Buongiorno Regione Lazio",
      sezioneTitolo: "Interviste e contenuti video",
    },
    links: [
      { label: "Visita il sito di Terziario Donna", url: "http://terziariodonna.confcommercio.it/", tipo: "external" },
    ],
  },

  {
    id: "giovani-imprenditori",
    urlOriginale: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/gruppi-trasversali/gruppo-giovani-imprenditori-roma/",
    intro: [
      "Il Gruppo Giovani Imprenditori Roma è costituito dagli imprenditori \"under 42\" aderenti a Confcommercio.",
      "Il Gruppo dei Giovani Imprenditori di Confcommercio Roma, costituitosi in Assemblea Elettiva il 17 novembre 2023, è un gruppo trasversale di cui fanno parte gli imprenditori e i liberi professionisti entro i 42 anni di tutte le categorie associative di Confcommercio Roma.",
      "Il Gruppo è orientato allo sviluppo delle imprese e delle attività professionali, con particolare attenzione alle tematiche dell'innovazione e dell'imprenditoria giovanile. A livello nazionale, il 50% degli associati opera nel commercio, il 30% nei servizi e il 20% nel turismo.",
      "A livello territoriale, il Gruppo supporta i propri associati anche in tutte quelle questioni legate alla complessità del panorama istituzionale e socio-economico della città di Roma.",
    ],
    presidente: {
      nome: "Eugenio Miccone",
      foto: "https://www.confcommercioroma.it/wp-content/uploads/2024/05/6b8e7d91-e09e-48be-9225-872ada375522-768x512.jpg",
      bio: [
        "Nato a Roma nel 1990, Eugenio Miccone lavora in Romana Diesel S.p.A. – family business – che è market leader nella commercializzazione di capital goods dal 1937 e di cui rappresenta la quarta generazione. L'azienda offre soluzioni e servizi nei settori on-road del trasporto di merci e persone e off-road dell'edilizia e dell'agricoltura.",
        "In Romana Diesel ha guidato il processo di digitalizzazione dell'aftermarket, ha realizzato l'ufficio Gare e si è occupato di lobbying. Con laurea in Scienze dell'Amministrazione e dell'Organizzazione e un MBA, vanta un background olistico. Dal 2020 al 2024 è stato Presidente del Gruppo Giovani Imprenditori di Confcommercio Federauto.",
      ],
    },
    consiglio: [
      { nome: "Eugenio Miccone", ruolo: "Presidente" },
      { nome: "Marta De Luca", ruolo: "Vicepresidente" },
      { nome: "Andrea Lucchesi", ruolo: "Vicepresidente" },
      { nome: "Andrea Paolantoni", ruolo: "Vicepresidente" },
      { nome: "Ottavia Pinci", ruolo: "Vicepresidente" },
      { nome: "Francesco Saverio Calvario", ruolo: "Consigliere" },
      { nome: "Federica Catalucci", ruolo: "Consigliere" },
      { nome: "Francesco Cianfarani", ruolo: "Consigliere" },
      { nome: "Alessandro D'Ilario", ruolo: "Consigliere" },
      { nome: "Niccolò De Carlo", ruolo: "Consigliere" },
      { nome: "Marta Di Giuseppe", ruolo: "Consigliere" },
      { nome: "Andrea Fassi", ruolo: "Consigliere" },
      { nome: "Simone Haddad", ruolo: "Consigliere" },
      { nome: "Francesco Iannotta", ruolo: "Consigliere" },
      { nome: "Alessandro Imperatore", ruolo: "Consigliere" },
      { nome: "Fabiola Miccone", ruolo: "Consigliere" },
      { nome: "Raffaele Nudi", ruolo: "Consigliere" },
      { nome: "Alice Poletto", ruolo: "Consigliere" },
      { nome: "Marco Rivolta Lippo", ruolo: "Consigliere" },
      { nome: "Maddalena Salerno", ruolo: "Consigliere" },
      { nome: "Vittorio Verardi", ruolo: "Consigliere" },
    ],
    contatti: {
      referente: "Filippo Aparo, Vanessa Tatini",
      indirizzo: "Via Marco e Marcelliano, 45 – 00147 Roma",
      tel: "06.68437353",
      email: "presidenzagiovani@confcommercioroma.it",
    },
    links: [
      { label: "Sito Web Giovani Imprenditori", url: "http://www.giovaniimprenditoriconfcommercio.it/", tipo: "external" },
    ],
  },

  // ── ASSOCIAZIONI TERRITORIALI ─────────────────────────────────────────

  {
    id: "centro-storico",
    urlOriginale: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/associazioni-territoriali/confcommercio-roma-centro-storico/",
    intro: [
      "L'Associazione Confcommercio Roma Centro Storico è il punto di riferimento per le attività commerciali e per le Associazioni di Via che operano nel Centro.",
    ],
    presidente: {
      nome: "Fabrizio Russo",
      foto: "https://www.confcommercioroma.it/wp-content/uploads/2025/02/russo-20-scaled.jpg",
      bio: [
        "Fabrizio Russo, presidente di Confcommercio Roma Centro Storico e titolare della storica Galleria Russo di via Alibert, ha individuato cinque punti su cui incentrare l'azione dell'Associazione:",
        "1. Il decoro della città e la sua pulizia: questi elementi rappresentano il biglietto da visita della Capitale e su questo tema c'è ancora moltissimo da fare.",
        "2. Trasporti e accessibilità: il prolungamento degli orari di apertura della metro, la rimodulazione delle tariffe per le strisce blu, la diminuzione dell'orario della ZTL ed una maggiore offerta di parcheggi di scambio.",
        "3. Illuminazione e video sorveglianza: scontistica ulteriore da applicare ai negozi che con la loro presenza rappresentano un servizio di decoro e sicurezza.",
        "4. Sicurezza stradale: installazione di telecamere di videosorveglianza, maggiore visibilità per i passaggi pedonali, defibrillatori nelle strade del centro storico.",
        "5. Grandi eventi: un'attenzione speciale al Giubileo 2025 e agli eventi che valorizzano la Capitale.",
      ],
    },
    consiglio: [
      { nome: "Fabrizio Russo", ruolo: "Presidente" },
      { nome: "Grazia Marino", ruolo: "Vicepresidente" },
      { nome: "Andrea Fassi", ruolo: "Consigliere" },
      { nome: "Mario Didone", ruolo: "Consigliere" },
      { nome: "Massimo Bertoni", ruolo: "Consigliere" },
      { nome: "Debora Soria", ruolo: "Consigliere" },
      { nome: "Pasquale Pennisi", ruolo: "Consigliere" },
      { nome: "Virgilio Cecchini", ruolo: "Consigliere" },
      { nome: "Antonella De Gregorio", ruolo: "Consigliere" },
    ],
    contatti: {
      indirizzo: "Via Marco e Marcelliano, 45 – 00147 Roma",
      email: "centrostoricoroma@confcommercioroma.it",
      tel: "06.68437620",
    },
  },

  {
    id: "civitavecchia",
    urlOriginale: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/associazioni-territoriali/confcommercio-civitavecchia-litorale-nord/",
    intro: [
      "Confcommercio Civitavecchia Litorale Nord tutela e rappresenta le imprese del commercio, del turismo e dei servizi operanti a Civitavecchia e lungo il litorale nord.",
      "Area territoriale rappresentata: Allumiere, Anguillara Sabazia, Bracciano, Cerveteri, Civitavecchia, Ladispoli, Manziana, Santa Marinella, Tolfa, Trevignano Romano.",
    ],
    presidente: {
      nome: "Graziano Luciani",
      foto: "https://www.confcommercioroma.it/wp-content/uploads/2024/01/luciani_graziano-300x218.jpg",
      bio: [
        "Nato a Civitavecchia, a poco più di 20 anni decide di diventare un imprenditore aprendo un negozio di frutta e verdura. Dopo un percorso fatto di enormi sforzi lavorativi, oggi gestisce da proprietario un supermercato a marchio \"Metà\" ed un supermercato nel centro cittadino a marchio \"Pam\".",
        "Svolge in questo momento il suo secondo mandato da Presidente, rieletto all'unanimità nel 2022. Porta avanti da sempre i rapporti tra i Commercianti e le varie Istituzioni garantendo che ogni diritto ed ogni dovere venga rispettato.",
      ],
    },
    consiglio: [
      { nome: "Graziano Luciani", ruolo: "Presidente" },
      { nome: "Cristiano Avolio", ruolo: "Consigliere" },
      { nome: "Roberto Serafini", ruolo: "Consigliere" },
      { nome: "Antonio Palomba", ruolo: "Consigliere" },
      { nome: "Luca Di Pomponio", ruolo: "Consigliere" },
      { nome: "Giulio Santoni", ruolo: "Consigliere" },
    ],
    contatti: {
      referente: "Cristiano Avolio",
      indirizzo: "Corso Guglielmo Marconi, 12 – 00053 Civitavecchia (Roma)",
      tel: "06.68437620",
      email: "civitavecchia@confcommercioroma.it",
      social: [{ label: "Facebook", url: "https://www.facebook.com/ConfcommercioCivitavecchia" }],
    },
  },

  {
    id: "litorale-sud",
    urlOriginale: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/associazioni-territoriali/ascom-confcommercio-roma-litorale-sud/",
    intro: [
      "Ascom Confcommercio Roma Litorale Sud tutela e rappresenta gli interessi diffusi delle imprese del territorio di Ostia, del X Municipio e del Litorale Sud.",
      "L'Associazione è da molti anni presente sul territorio e si pone come punto di riferimento al quale si rivolgono le imprese e i potenziali imprenditori operanti nei settori del commercio, turismo, servizi e professioni.",
      "Rappresenta gli interessi delle imprese associate interloquendo con Enti pubblici e privati, offre servizi di formazione e di credito e garantisce un servizio informativo per essere sempre aggiornati su adempimenti, normative e attività svolte sul territorio del litorale romano.",
    ],
    presidente: {
      nome: "Valeria Strappini",
      foto: "https://www.confcommercioroma.it/wp-content/uploads/2024/01/foto-Strappini-232x300.jpg",
      bio: [
        "Valeria Strappini, figlia d'arte, viene dal mondo della ristorazione imparando il mestiere del padre nella \"Re Carlo Ricevimenti\". Ha diretto e gestito l'azienda di famiglia, il ristorante \"Re Carlo Bistrot\", servizi di ristorazione nei stabilimenti balneari e \"il catering di Ostia\". Sommelier dal 2004.",
        "Mamma di due bambine, amante del territorio di Ostia dove ha improntato la sua vita privata e aziendale. Attualmente ricopre cariche politico-sindacali in Confcommercio: Presidente Ascom Litorale Sud, Vicepresidente Confcommercio Roma, Vicepresidente FIPE Roma. Fautrice del progetto \"Chiedi se c'è Angela\" a difesa della violenza di genere, attiva nella lotta contro l'usura e l'abusivismo.",
      ],
    },
    consiglio: [
      { nome: "Valeria Strappini", ruolo: "Presidente" },
      { nome: "Luigi Gattuso", ruolo: "Consigliere" },
      { nome: "Edoardo Moscara", ruolo: "Consigliere" },
      { nome: "Simone Haddad", ruolo: "Consigliere" },
      { nome: "Stefano Travaglini", ruolo: "Consigliere" },
      { nome: "Masina Pala", ruolo: "Consigliere" },
      { nome: "Antonio Corrado", ruolo: "Consigliere" },
      { nome: "Alessandro Gabriele", ruolo: "Consigliere" },
      { nome: "Federico Calvanese", ruolo: "Consigliere" },
      { nome: "Fabrizio Ciadini", ruolo: "Consigliere" },
      { nome: "Veronica Milli", ruolo: "Consigliere" },
      { nome: "Maria Diletta Lanna", ruolo: "Consigliere" },
    ],
    contatti: {
      referente: "Pina Mignano",
      indirizzo: "Piazzale della Posta, 2 – 00122 Ostia Lido – Roma",
      tel: "06.5623356",
      email: "ostia@confcommercioroma.it",
      orari: "Lunedì, martedì, giovedì 9:00–12:00. Accesso su appuntamento lun–ven 9:00–14:00.",
      social: [{ label: "Facebook", url: "https://www.facebook.com/ascomconfcommercioroma" }],
    },
  },
];

export default ASSOC_DETTAGLIO;
